module.exports = (__webpack_require__(837))(6710);